import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';

@Component({
  selector: 'app-auto-string-creation',
  templateUrl: './auto-string-creation.component.html',
  styleUrls: ['./auto-string-creation.component.css']
})
export class AutoStringCreationComponent {
  local_data: any;
  title: string = '';
  // isBatch = true;
  serialBatchNoCriteria = [{
    text: "",
    type: '',
    operation: ''
  },
  {
    text: "",
    type: '',
    operation: ''
  }]
  constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>,
              public snackbarService: BaseService<any>) { 
    this.local_data = data;
    this.title = this.local_data.label;
    // this.isBatch = this.local_data.manageBatchNumbers == "Y";            
  }

  initAutoStringCreation() {
    // this.serialBatchNoCriteria.type = this.local_data.type;
    if(this.serialBatchNoCriteria.every(el => el.type && el.text)) {
      if(this.serialBatchNoCriteria.find(el => el.type == "number")?.operation == "") {
        this.snackbarService.showMessage('Please select operation type for number', 'X')
      }else {
        this.dialogRef.close({ event: true, value: this.serialBatchNoCriteria}); 
      }
    }else {
      this.snackbarService.showMessage('Please fill all mandatory fields', 'X')
    }
  }

}
